import React from 'react';
import clsx from 'clsx';
import Wrapper from './Layout/Wrapper';
import { Heading } from '../Elements/Heading';

const PageHeader = ({ title, preTitle, allCapsTitle, withLessMargin = false }) => {
    return (
        <div className={clsx('page-header', { 'page-header--less-margin': withLessMargin })}>
            { preTitle ? (
                <Wrapper>
                    <p className="heading-small page-header__pretitle">{preTitle}</p>
                </Wrapper>
            ) : null }
            <Heading level={1} size="large" text={title} center allCaps={allCapsTitle} />
        </div>
    );
}

export default PageHeader;

